module.exports = __webpack_public_path__ + "img/2.0f96ea3.jpg";